//src/types/Store/StoreEnums.ts

export enum NotificationType {
  customer = 'Customer',
  aircraft = 'Aircraft',
  store = 'Store',
  maintenance = 'Maintenance',
  scheduling = 'Scheduling'
}

export enum NotificationMethod {
  email = 'Email',
  text = 'Text',
  both = 'Email and Text'
}

export enum NotificationTrigger {
  add = 'Add',
  update = 'Update',
  delete = 'Delete',
  unset = 'Unset'
}

export type Triggers = NotificationTrigger | MaintenanceTrigger | ScheduleTrigger

export enum MaintenanceTrigger {
  squawk = 'Squawk Submitted',
  squawkGrnd = 'Squawk Grounded',
  squawkCompleted = 'Squawk Completed',
  dateApproaching = 'Date Approaching',
  dateImminent = 'Date Imminent',
  datePastdue = 'Date Past Due',
  maintChanged = 'Maintenance Changed'
}

export enum ScheduleTrigger {
  add = 'Schedule Added',
  edit = 'Schedule Edited',
  delete = 'Schedule Deleted',
  checkOut = 'Checked Out',
  checkIn = 'Check In',
  cancelCheckOut = 'Cancel Check Out',
  notCheckedOut = 'Not Checked Out'
}

export enum Module {
  Equipment = 'Equipment',
  Logbook = 'Logbook',
  Scheduling = 'Scheduling',
  Maintenance = 'Maintenance',
  /**
   * Work Orders (src/utils/maintenance/workOrderData.ts) — in-house maintenance
   * work orders built from squawks and tasks. Needs the Maintenance module
   * too; with it off, squawks work exactly as before. The value must stay
   * 'WorkOrders' — firestore.rules checks storeHasModule(storeId, 'WorkOrders').
   */
  WorkOrders = 'WorkOrders',
  Part141 = 'Part141',
  Leads = 'Leads',
  Reports = 'Reports',
  Rooms = 'Rooms',
  Finance = 'Finance',
  Notification = 'Notification',
  Client = 'Client',
  Fueling = 'Fueling',
  FuelReceipts = 'FuelReceipts',
  TimeClock = 'TimeClock'
}

export enum ComponentTitle {}

export enum CalendarView {
  day = 'resourceTimelineDay',
  week = 'timeGridWeek',
  month = 'dayGridMonth'
}
